import { observer } from "mobx-react-lite";
import { SidebarTrigger } from "ui";
import { cn } from "ui";

import { ChatButton } from "src/chat/ChatButton";
import { AccountMenu } from "src/components/AccountMenu";
import { useBreadcrumbs } from "src/hooks/useBreadcrumbs";
import { NotificationButton } from "src/notifications/Notifications";

import { useSetContentElement } from "./AuthenticatedNavigationContext";
import { NavbarSavingIndicator } from "./NavbarSavingIndicator";
import { TrialEndChip } from "./TrialEndChip";

interface Props {
  className?: string;
  sidebarShown?: boolean;
  title?: string;
}

export const AuthenticatedNavigation = observer(
  function AuthenticatedNavigation(props: Props) {
    const setContentElement = useSetContentElement();
    const breadcrumbs = useBreadcrumbs();

    return (
      <nav
        className={cn(
          "sidebar-left-shift fixed top-0 z-50 right-0 h-sztama-auth-toolbar-height flex justify-between items-center border-b bg-white px-2",
          props.className,
        )}
      >
        <div className={"flex w-full items-center"}>
          {props.sidebarShown === false ? null : (
            <SidebarTrigger className="w-8 h-8 p-0 rounded-[0.5rem]" />
          )}
          <div className="h-4 w-px bg-border mr-4 ml-2"></div>
          {props.title ? (
            <div className="w-full text-sm">{props.title}</div>
          ) : breadcrumbs ? (
            <div className="w-full">{breadcrumbs}</div>
          ) : (
            <div ref={setContentElement} className="w-full" />
          )}
        </div>
        <div className="flex gap-2 items-center">
          <TrialEndChip />
          <NavbarSavingIndicator />
          {props.sidebarShown === false ? (
            <>
              <ChatButton />
              <NotificationButton />
              <AccountMenu />
            </>
          ) : null}
        </div>
      </nav>
    );
  },
);
